import { ChangeDetectionStrategy, Component } from '@angular/core'
import { environment } from '../environments/environment'

@Component({
  selector: 'papi-partner-ui',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  title = 'partner-ui'
  version = environment.version
}
